export default {
  nav: {
    main: 'Glavna',
    ordersAndInvoices: 'Narudžbe i računi',
    drafts: 'Skice',
    automation: 'Automatizacija',
    workspace: 'Radni prostor',
    templates: 'Predlošci',
    delivery: 'Dostava',
    settings: 'Postavke',
    shippingLabels: 'Naljepnice za dostavu',
    subscriptions: 'Pretplate',
    support: 'Podrška',
    developer: 'Razvoj',
    writeReview: 'Napiši recenziju',
    supportTicket: 'Zahtjev za podršku',
    welcomeTour: 'Obilazak dobrodošlice',
    administratorConsole: 'Administratorska konzola',
    logout: 'Odjava',
  },
  dashboard: {
    pageTitle: 'Narudžbe i računi',
    pageDescription: 'Manage your orders and invoices',
    title: 'Narudžbe i računi',
    selectedOrders: '{count} odabranih narudžbi',
    completed: '% završeno',
    processing: 'Obrada, molimo pričekajte...',
    bulkDownload: 'Skupno preuzimanje',
    upgradeBulkDownload: 'Nadogradite plan za skupno preuzimanje',
    showFilters: 'Prikaži filtere',
    hideFilters: 'Sakrij filtere',
    creatingInvoices: 'Kreiranje računa, molimo pričekajte...',
    bulkCreateInvoices: 'Skupno kreiranje računa',
    cannotCreateAutopilot: 'Ne možete ručno kreirati račune kada je način fakturiranja na automatskom pilotu.',
    exportInvoices: 'Izvezi račune ili narudžbe',
    capturePayments: 'Ručno naplati plaćanja',
    filterOrders: 'Filtriraj narudžbe',
    error: 'Ups, nešto je pošlo po krivu...',
    close: 'Zatvori',
    chooseDate: 'Odaberite datum',
    chooseIssueDate: 'Odaberite datum izdavanja za odabrane račune',
    cancel: 'Odustani',
    createInvoices: 'Kreiraj račune',
    storno: 'Storno',
    bulkOrderCapture: 'Skupna naplata narudžbi',
  },
  search: {
    createdBetween: 'Kreirano između',
    modifiedBetween: 'Izmijenjeno između',
    orderNumber: 'Narudžba #',
    invoiceNumber: 'Račun #',
    refundNumber: 'Povrat #',
    customer: 'Kupac',
    payment: 'Plaćanje',
    any: 'Bilo koji',
    authorized: 'Autorizirano',
    pending: 'Na čekanju',
    paid: 'Plaćeno',
    partiallyPaid: 'Djelomično plaćeno',
    refunded: 'Vraćeno',
    voided: 'Poništeno',
    partiallyRefunded: 'Djelomično vraćeno',
    unpaid: 'Neplaćeno',
    fulfillment: 'Ispunjenje',
    fulfilled: 'Isporučeno',
    partial: 'Djelomično',
    unfulfilled: 'Neisporučeno',
    loading: 'Učitavanje narudžbi...',
    search: 'Pretraži',
  },
  orderList: {
    noCustomer: 'Nema kupca',
    downloadOrder: 'Preuzmi narudžbu',
    deleteWarning: 'Važno! Ovo će izbrisati sve račune i povrate kreirane nakon datuma:',
    includingInvoice: 'uključujući odabrani račun #',
    pressOk: 'Pritisnite OK za nastavak ili Odustani za prekid.',
    cannotCreateAutopilot: 'Ne možete ručno kreirati račune kada je način fakturiranja na automatskom pilotu.',
    createInvoice: 'Kreiraj račun za ovu narudžbu',
    create: 'Kreiraj',
    addCreditNote: 'Dodaj knjižno odobrenje',
    createStorno: 'Kreiraj storno račun',
    refund: 'Povrat',
    downloadInvoice: 'Preuzmi ovaj račun',
    download: 'Preuzmi',
    default: 'Zadano',
    downloadStorno: 'Preuzmi ovaj storno/knjižno odobrenje',
    fulfillOrder: 'Ispuni narudžbu',
    orderNum: 'Narudžba #',
    locPrefix: 'Prefiks lokacije',
    invoiceNum: 'Račun #',
    refundNum: 'Povrat #',
    customerCol: 'Kupac',
    orderCreatedDate: 'Datum kreiranja narudžbe',
    orderModifiedDate: 'Datum izmjene narudžbe',
    delivered: 'Dostavljeno',
    paymentStatus: 'Status plaćanja',
    fulfillmentStatus: 'Status isporuke',
    totalOutstanding: 'Ukupni nepodmireni iznos',
    originalPrice: 'Izvorna cijena',
    noOrders: 'Vaša trgovina nema narudžbi za odabrani status.',
    cannotCreateNoOrders: 'Ne možete kreirati račune kada nema narudžbi.',
    createOrdersFirst: 'Molimo kreirajte barem jednu narudžbu i pokušajte ponovo.',
    createOrders: 'Kreiraj narudžbe',
    loadingOrders: 'Učitavanje...',
    paidManual: 'Plaćeno - Ručno',
    paid: 'Plaćeno',
    refunded: 'Vraćeno',
    pending: 'Na čekanju',
    partiallyPaid: 'Djelomično plaćeno',
    partiallyRefunded: 'Djelomično vraćeno',
    fulfilled: 'Isporučeno',
    unfulfilled: 'Neisporučeno',
    deliveryPending: 'Na čekanju',
    deliverNow: 'Dostavi sada',
    deliveryPartial: 'Djelomična',
    notDelivered: 'Nije dostavljeno',
    deliverAgain: 'Dostavi ponovo',
    deliveryDetails: 'Detalji dostave',
    deliveryFailed: 'Dostava neuspješna',
    sent: 'Poslano',
    failed: 'Neuspjelo',
    toLabel: 'Prima',
    folderLabel: 'Mapa',
    open: 'Otvoreno',
    invoice: 'Račun',
    creditNote: 'Knjižno odobrenje',
    stornoLabel: 'Storno',
    unknown: 'Nepoznato',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet klijenata',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-pošta',
    ftpChannel: 'FTP',
    revertToDate: 'Vrati na ovaj datum',
    add: 'Dodaj',
    close: 'Zatvori',
  },
  downloadDialog: {
    downloadType: 'Preuzmi {type}...',
    selectTemplate: 'Odaberite predložak iz galerije za izvoz narudžbi, računa, storno računa ili knjižnih odobrenja.',
    getMoreTemplates: 'Nabavi više predložaka',
    createNewTemplate: 'Kreiraj novi predložak',
    allCreatedBetween: 'Svi kreirani {type} između',
    selectedType: 'Odabrani {type}',
    and: 'i',
    status: 'Status',
    any: 'Bilo koji',
    open: 'Otvoreno',
    closed: 'Zatvoreno',
    cancelled: 'Otkazano',
    paymentStatus: 'Status plaćanja',
    fulfillmentStatus: 'Status isporuke',
    fulfilled: 'Isporučeno',
    partial: 'Djelomično',
    unfulfilled: 'Neisporučeno',
    authorized: 'Autorizirano',
    pending: 'Na čekanju',
    paid: 'Plaćeno',
    partiallyPaid: 'Djelomično plaćeno',
    refunded: 'Vraćeno',
    voided: 'Poništeno',
    partiallyRefunded: 'Djelomično vraćeno',
    unpaid: 'Neplaćeno',
    format: 'Format',
    forLocation: 'Za lokaciju',
    advancedOptions: 'Napredne opcije',
    exportHSCodes: 'Izvezi HS kodove inventara (sporije)',
    noteChrome: 'Napomena: Za optimalno preuzimanje preporuča se Chrome i isključivanje blokatora oglasa.',
    downloadIndividually: 'Preuzmi pojedinačno',
    downloadGrouped: 'Preuzmi grupirano',
  },
  templates: {
    pageTitle: 'Predlošci',
    pageDescription: 'Customize your invoice templates',
    title: 'Predlošci',
    installTranslated: 'Instaliraj prevedeni predložak',
    installTranslatedDesc: 'Odaberite drugi jezik klikom na ovaj gumb.',
    createNew: 'Kreirajte novi predložak ako je potrebno',
    createNewDesc: 'Kliknite na ovaj gumb za kreiranje novog predloška ako je potrebno.',
    customize: 'Prilagodi predloške',
    customizeDesc: 'Kliknite na zadani predložak za prilagodbu. Možete promijeniti logotip, boje, a za naprednije korisnike i kod iza predloška.',
    defaultTemplate: 'Račun, storno i knjižno odobrenje (Zadano)',
    logo: 'Logotip',
    colorPalette: 'Paleta boja',
    getColorPalettes: 'Nabavi palete boja',
    paperSize: 'Veličina papira',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orijentacija',
    landscape: 'Pejzaž',
    portrait: 'Portret',
    margin: 'Margina (cm)',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    save: 'Spremi',
  },
  labels: {
    pageTitle: 'Naljepnice za dostavu',
    pageDescription: 'Create and manage shipping labels',
    title: 'Naljepnice za dostavu',
    glsRequiresPro: 'GLS naljepnice za dostavu za EEU zahtijevaju Professional plan.',
    upgradeDesc: 'Nadogradite na Professional za kreiranje i upravljanje naljepnicama za dostavu.',
    upgradePlan: 'Nadogradite plan',
    eeuGls: 'EEU GLS',
    enabled: 'Omogućeno',
    country: 'Država',
    hungary: 'Mađarska',
    slovakia: 'Slovačka',
    czech: 'Češka',
    romania: 'Rumunjska',
    slovenia: 'Slovenija',
    croatia: 'Hrvatska',
    senderId: 'ID pošiljatelja',
    username: 'Korisničko ime',
    password: 'Lozinka',
    name: 'Ime',
    city: 'Grad',
    address: 'Adresa',
    zipCode: 'Poštanski broj',
    contactPerson: 'Kontakt osoba',
    phone: 'Telefon',
    email: 'E-pošta',
    glsServices: 'GLS usluge',
    expressService: 'Ekspresna usluga',
    exchangeService: 'Usluga zamjene',
    smsService: 'SMS usluga',
    smsText: 'SMS tekst',
    preAdviceService: 'Usluga prethodne najave',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    save: 'Spremi',
  },
  billing: {
    pageTitle: 'Naplata',
    pageDescription: 'Manage your subscription and billing',
    title: 'Naplata',
    subscriptionFor: 'Plan pretplate za trgovinu',
    currentlySubscribed: 'Trenutno ste pretplaćeni na',
    plan: 'plan',
    cancelSubscription: 'Otkaži pretplatu',
    upgradePlan: 'Nadogradite plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mjesečno',
    upgrade: 'Nadogradi',
    includesAllStarter: 'Uključuje sve značajke Starter plana, plus:',
    proFeature1: 'Globalna usklađenost: Prefiksi temeljeni na lokaciji i prilagođeno sekvencijalno numeriranje',
    proFeature2: 'Pametna lokalizacija: Automatski prevedene e-poruke i lokalizirani PDF prilozi',
    proFeature3: 'Cjeloviti B2B ciklus dokumenata: Predračuni, B2B ponude i knjižna odobrenja',
    proFeature4: 'B2B računovodstvena sinkronizacija: Preciznost na 3 decimale i prikaz više valuta',
    proFeature5: 'Automatizirane sigurnosne kopije: Automatsko kopiranje računa na sigurni FTP ili Google Drive',
    proFeature6: 'Shopify Flow: Automatizirajte generiranje, dostavu i storniranje računa putem Flow okidača i akcija',
    proFeature7: 'Napredna AI logika: Koristite AI na uređaju za složene uvjetne klauzule izgleda',
    proFeature8: 'UBL XML i ZUGFeRD / Factur-X izvozi (usklađenost s europskim e-fakturiranjem)',
    proFeature9: 'EPC QR kodovi za brza mobilna POS plaćanja',
    proFeature10: 'GLS naljepnice za dostavu za EEU',
    proFeature11: '7-godišnje čuvanje porezne dokumentacije',
    currentlyUsing: 'Trenutno koristite naš',
    free: 'besplatni',
    subscriptionPlan: 'plan pretplate.',
    monthlyUsage: 'Mjesečna potrošnja',
    monthlyGenerated: '{count} / 50 računa ovog mjeseca',
    monthlyLimitReached: 'Mjesečni limit dosegnut. Nadogradite na Starter za neograničene račune.',
    freePlan: 'Besplatni plan',
    freeToInstall: 'Besplatna instalacija',
    freeFeature1: 'Do 50 računa/narudžbi mjesečno',
    freeFeature2: 'Pristup svim 31+ predefiniranim predlošcima',
    freeFeature3: 'Osnovni AI Copilot',
    freeFeature4: 'Standardno preuzimanje i ispis PDF-a',
    freeFeature5: 'Standardni paket dokumenata (Računi, otpremnice, potvrde)',
    freeFeature6: '3-mjesečno sigurno čuvanje računa',
    starterPlan: 'Starter plan',
    starterPrice: '$9.99 / mjesečno',
    starterPricePerInvoice: '+ 3¢ po kreiranom računu',
    subscribe: 'Pretplati se',
    starterFeature1: 'Neograničeni računi i narudžbe',
    starterFeature2: 'Automatska dostava PDF-a putem e-pošte',
    starterFeature3: 'Puni pristup hibridnom uređivaču i AI Copilotu',
    starterFeature4: 'Shopify POS i integracija crtičnih kodova',
    starterFeature5: 'Shopify Flow: Okidači i akcije za automatizaciju fakturiranja',
    starterFeature6: 'UBL XML / PEPPOL i ZUGFeRD / Factur-X izvozi (usklađenost s e-fakturiranjem)',
    starterFeature7: '1-godišnje sigurno čuvanje računa',
    proTaxOverrides: 'Prilagođeno nadjačavanje poreza: PDV po proizvodu i stope po SKU razini',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    save: 'Spremi',
  },
  autopilot: {
    pageTitle: 'Automatizacija',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizacija',
    autoCreate: 'Automatski kreiraj račune',
    disabled: 'Onemogućeno (Ručno)',
    whenCreated: 'Kada su narudžbe kreirane',
    whenFulfilled: 'Kada su narudžbe ispunjene',
    whenPaid: 'Kada su narudžbe plaćene',
    autoCreateDesc: 'Računi će biti kreirani na datum kada su narudžbe kreirane, ispunjene ili plaćene.',
    autoStorno: 'Automatski storniraj račune',
    whenCancelled: 'Kada su narudžbe otkazane ili vraćene',
    autoStornoDesc: 'Storno računi će biti kreirani na datum kada su narudžbe poništene/otkazane ili kada su kreirani povrati.',
    cannotAutoFree: 'Automatsko kreiranje računa nije moguće s besplatnim planom.',
    upgradePlan: 'Nadogradite plan',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    save: 'Spremi',
  },
  delivery: {
    pageTitle: 'Dostava',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Dostava',
    settings: 'Postavke',
    useOrderNumbers: 'Koristi brojeve narudžbi za datoteke',
    sendIfCountry: 'Pošalji ako je država adrese za naplatu',
    countryCodesHint: 'Navedite sve kodove država odvojene točkom-zarezom.',
    sendForTags: 'Pošalji za kupce koji imaju jednu od navedenih oznaka',
    tagsHint: 'Navedite sve oznake odvojene točkom-zarezom.',
    emailDelivery: 'Dostava e-poštom',
    sendAsPdf: 'Šalji račune kao PDF privitke kupcima',
    autoSend: 'Automatski pošalji kada je račun kreiran',
    subject: 'Predmet',
    body: 'Tijelo poruke',
    xmlAttachments: 'XML privitci',
    attachUbl: 'Priloži UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Priloži ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Pošalji testnu e-poruku',
    sending: 'Slanje...',
    customSmtp: 'Prilagođeni SMTP poslužitelj',
    customSmtpDesc: 'Koristite vlastiti poslužitelj e-pošte umjesto zadanog',
    enableSmtp: 'Omogući prilagođeni SMTP',
    smtpHost: 'SMTP poslužitelj',
    port: 'Port',
    useSsl: 'Koristi SSL/TLS',
    username: 'Korisničko ime',
    password: 'Lozinka',
    fromEmail: 'E-pošta pošiljatelja',
    fromName: 'Ime pošiljatelja',
    shopifyLiquid: 'Shopify Liquid predložak',
    pasteInto: 'Zalijepite ovo u vaš',
    orderConfirmation: 'predložak potvrde narudžbe',
    toAddLink: 'za dodavanje poveznice za preuzimanje.',
    downloadInvoice: 'Preuzmite svoj račun',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Šalji zahtjeve na ClientsTablet kada su računi kreirani',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Šalji PDF račune kao carinske dokumente na ShippyPro za zemlje izvan EU',
    ftpBackup: 'FTP / SFTP sigurnosna kopija',
    ftpDesc: 'Automatski kopiraj račune na vaš poslužitelj',
    enableFtp: 'Omogući automatsku FTP sigurnosnu kopiju',
    host: 'Poslužitelj',
    useSftp: 'Koristi SFTP (sigurno)',
    destinationFolder: 'Odredišna mapa',
    xmlFiles: 'XML datoteke',
    includeUbl: 'Uključi UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Uključi ZUGFeRD / Factur-X XML',
    testConnection: 'Testiraj vezu',
    testing: 'Testiranje...',
    pro: 'PRO',
    upgradeFtp: 'Nadogradite na Professional za automatsko kopiranje računa na vaš FTP/SFTP poslužitelj.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automatski sinkroniziraj račune na vaš Drive',
    connected: 'Povezano',
    disconnect: 'Prekini vezu',
    notWorking: 'Ne radi? Idite na',
    googlePermissions: 'Google dozvole',
    removeThenReconnect: 'uklonite Invoice Browse, zatim se ponovno povežite.',
    connectGoogleDrive: 'Poveži Google Drive',
    upgradeGoogleDrive: 'Nadogradite na Professional za automatsku sinkronizaciju računa na Google Drive.',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Spremi',
  },
  bookkeeping: {
    pageTitle: 'Postavke',
    pageDescription: 'Configure your invoice settings',
    title: 'Postavke',
    owner: 'Vlasnik',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Zadrži različito numeriranje računa za svaku lokaciju narudžbe',
    keepDifferentNumberingDisabled: 'Zadržavanje različitog numeriranja računa za svaku lokaciju narudžbe nije opcija omogućena s vašim planom.',
    locationEmailDesc: 'Ovo vam omogućuje slanje e-poruka i računa prevedenih na temelju lokacije narudžbe: lokacija inventara, adresa dostave ili adresa za naplatu',
    upgradePlan: 'Nadogradite plan',
    matchingCriteria: 'Kriteriji podudaranja',
    locationId: 'ID lokacije',
    shippingCountryCode: 'Kod države adrese dostave',
    billingCountryCode: 'Kod države adrese za naplatu',
    matchLocationDesc: 'Podudari lokaciju na temelju ID-a lokacije narudžbe, koda države adrese dostave ili adrese za naplatu.',
    companyInfo: 'Podaci o tvrtki',
    name: 'Naziv',
    website: 'Web stranica',
    registrationNumber: 'Matični broj',
    taxId: 'OIB',
    addressSection: 'Adresa',
    streetName: 'Naziv ulice',
    streetNumber: 'Kućni broj',
    zip: 'Poštanski broj',
    city: 'Grad',
    region: 'Regija',
    country: 'Država',
    bankingInfo: 'Bankovni podaci',
    bankName: 'Naziv banke',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fakturiranje',
    decimalPlaces: 'Decimalna mjesta',
    invoicesPrefix: 'Prefiks računa',
    currentInvoiceNumber: 'Trenutni broj računa',
    creditNotesPrefix: 'Prefiks knjižnih odobrenja',
    currentCreditNoteNumber: 'Trenutni broj knjižnog odobrenja',
    lastInvoiceDate: 'Datum zadnjeg računa',
    noInvoicesYet: 'Još nema kreiranih računa.',
    confirmReverting: 'Potvrda vraćanja sustava',
    allInvoicesAfter: 'Svi računi i njihovi storna izdani nakon',
    willBeRemoved: 'bit će uklonjeni. Nastaviti s vraćanjem sustava?',
    cancel: 'Odustani',
    revert: 'Vrati',
    revertDesc: 'Vraćanje sustava će izbrisati sve račune kreirane nakon odabranog datuma.',
    revertToDate: 'Vrati na ovaj datum',
    reverting: 'Vraćanje sustava, molimo pričekajte...',
    useOrderNumbering: 'Koristi numeriranje narudžbi',
    showVat: 'Prikaži PDV na računima',
    overrideTaxes: 'Nadjačaj poreze',
    pricesIncludeTax: 'Cijene uključuju porez',
    productsTaxRate: 'Porezna stopa proizvoda',
    shippingTaxRate: 'Porezna stopa dostave',
    skusSeparated: 'SKU-ovi odvojeni točkom-zarezom',
    skusTaxRate: 'Porezna stopa SKU-ova',
    useOrderDates: 'Koristi datume kreiranja narudžbi za račune',
    convertCurrency: 'Pretvori cijene u valutu u kojoj kupac plaća',
    unsavedChanges: 'Nespremljene promjene',
    discard: 'Odbaci',
    save: 'Spremi',
  },
  drafts: {
    pageTitle: 'Skice',
    pageDescription: 'Manage your draft orders',
    title: 'Skice',
    download: 'Preuzmi',
    newDraft: 'Nova skica',
    exporting: 'Izvoz {status}%...',
    accessNotGranted: 'Pristup skicama narudžbi nije odobren. Molimo',
    reLogin: 'prijavite se ponovo',
    toGrantPermissions: 'za odobravanje potrebnih dozvola za "Skice narudžbi".',
    pushFailed: 'Slanje na Shopify nije uspjelo:',
    exportError: 'Greška pri izvozu:',
    confirmDelete: 'Jeste li sigurni da želite izbrisati ovu skicu?',
    incompleteCustomer: 'Podaci o kupcu su nepotpuni:',
    pushWithoutCustomer: 'Skica će biti poslana na Shopify bez podataka o kupcu. Nastaviti?',
    customerNotInShopify: 'Ovaj kupac još ne postoji u Shopify sustavu.',
    warnings: 'Upozorenja:',
    createCustomerAndPush: 'Kreirati kupca u Shopify sustavu i poslati skicu narudžbe?',
    downloadTitle: 'Preuzmi skice',
    cancel: 'Odustani',
  },
  draftEdit: {
    number: "Broj",
    prefix: "Prefiks",

    newDraft: 'Nova skica',
    editDraft: 'Uredi skicu',
    viewInShopify: 'Pogledaj u Shopify',
    back: 'Natrag',
    createDraft: 'Kreiraj skicu',
    saveChanges: 'Spremi promjene',
    documentType: 'Vrsta dokumenta',
    draftOrder: 'Skica narudžbe',
    quote: 'Ponuda',
    proforma: 'Predračun',
    manualInvoice: 'Ručni račun',
    currency: 'Valuta',
    expiryDate: 'Datum isteka',
    status: 'Status',
    draft: 'Skica',
    sent: 'Poslano',
    accepted: 'Prihvaćeno',
    customer: 'Kupac',
    firstName: 'Ime',
    lastName: 'Prezime',
    email: 'E-pošta',
    phone: 'Telefon',
    company: 'Tvrtka',
    taxId: 'OIB',
    billingAddress: 'Adresa za naplatu',
    address: 'Adresa',
    aptSuite: 'Stan/ured',
    city: 'Grad',
    province: 'Županija',
    countryField: 'Država',
    zip: 'Poštanski broj',
    shippingAddress: 'Adresa dostave',
    sameAsBilling: 'Isto kao adresa za naplatu',
    lineItems: 'Stavke',
    shipping: 'Dostava',
    shippingTitle: 'Naslov',
    shippingPlaceholder: 'npr. Standardna dostava',
    price: 'Cijena',
    note: 'Napomena',
    notePlaceholder: 'Interna napomena ili poruka kupcu...',
    summary: 'Sažetak',
    subtotal: 'Međuzbroj',
    discounts: 'Popusti',
    tax: 'Porez',
    total: 'Ukupno',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Unesite adresu svoje trgovine',
    loginWith: 'Prijava putem',
    createAccount: 'Kreirajte novi račun',
    placeholder: 'naziv-vase-trgovine',
    shopRequired: 'Naziv trgovine je obavezan',
    login: 'Prijava',
    shopify: 'Shopify',
    terms: 'Uvjeti korištenja',
    privacy: 'Pravila privatnosti',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Uživate u Invoice Browse?',
    description: 'Kreirali ste svoje prve račune! Ako vam je aplikacija korisna, brza recenzija na Shopify App Storeu nam puno znači.',
    reward: 'Kao zahvalu, resetirat ćemo vaš mjesečni brojač potrošnje na 0',
    leaveReview: 'Ostavi recenziju',
    maybeLater: 'Možda kasnije',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Dobrodošli u Invoice Browse',
    welcomeContent: 'Dopustite mi da vam pokažem kako ga možete koristiti.',
    dashboardTitle: 'Nadzorna ploča',
    dashboardContent: 'Zaslon koji vidite je glavna nadzorna ploča. Ovdje možete pronaći sve narudžbe i izvesti ih u različite vrste dokumenata kao što su: računi, otpremnice i drugi.',
    automationTitle: 'Olakšajte si život',
    automationContent: 'Omogućite automatizaciju za kreiranje računa kad god su narudžbe plaćene ili vraćene.',
    templatesTitle: 'Prilagodi predloške',
    templatesContent: 'Uđite ovdje za prevođenje predloška, prilagodbu ili kreiranje novog.',
    deliveryTitle: 'Dostava',
    deliveryContent: 'Konfigurirajte našu aplikaciju za automatsko kopiranje kreiranih dokumenata na FTP, Google Drive ili kao privitke za e-poruke.',
    settingsTitle: 'Postavke',
    settingsContent1: 'Prilagodite telefonski broj tvrtke, e-poštu i ostala polja koja se koriste na dokumentima.',
    settingsContent2: 'Promijenite početni broj dokumenta ili izbrišite dokumente kreirane nakon određenog datuma.',
    settingsContent3: 'Nadjačajte PDV stope za dostavu i proizvode',
    settingsContent4: 'Promijenite decimalna mjesta za brojeve',
    reviewTitle: 'Napišite recenziju',
    reviewContent: 'Podržite naš tim pisanjem dobre recenzije!',
    tourTitle: 'Obilazak dobrodošlice',
    tourContent: 'Hej, ovaj obilazak možete ponovno otvoriti odavde.',
    createDocTitle: 'Kreirajte svoj prvi dokument',
    createDocContent: 'Kliknite na gumb Kreiraj za kreiranje svog prvog dokumenta.',
    docNumberTitle: 'Broj dokumenta',
    docNumberContent: 'Prvom dokumentu je dodijeljen broj 1. Ako želite započeti s drugim brojem, to možete promijeniti u Postavkama.',
    downloadDocTitle: 'Preuzmi dokument',
    downloadDocContent: 'Kliknite na padajući izbornik Preuzmi i odaberite predložak dokumenta za izvoz narudžbe kao PDF.',
  },
  common: {
    save: 'Spremi',
    cancel: 'Odustani',
    close: 'Zatvori',
    discard: 'Odbaci',
    delete: 'Izbriši',
    edit: 'Uredi',
    create: 'Kreiraj',
    loading: 'Učitavanje...',
    unsavedChanges: 'Nespremljene promjene',
    upgradePlan: 'Nadogradite plan',
  },
  languageSelector: {
    label: 'Jezik',
    auto: 'Automatsko prepoznavanje',
  },
  draftList: {
    draftNum: 'Skica #',
    shopifyId: 'Shopify ID',
    type: 'Tip',
    customer: 'Kupac',
    total: 'Ukupno',
    status: 'Status',
    delivered: 'Dostavljeno',
    date: 'Datum',
    actions: 'Radnje',
    noCustomer: 'Nema kupca',
    noDrafts: 'Nije pronađena nijedna skica ili ponuda.',
    loading: 'Učitavanje...',
    download: 'Preuzmi',
    default: 'Zadano',
    pending: 'Na čekanju',
    deliverNow: 'Dostavi sada',
    deliveryDetails: 'Detalji dostave',
    sent: 'Poslano',
    failed: 'Neuspjelo',
    deliverAgain: 'Dostavi ponovo',
    partial: 'Djelomično',
    notDelivered: 'Nije dostavljeno',
    deliveryFailed: 'Dostava neuspjela',
    unknown: 'Nepoznato',
    edit: 'Uredi',
    send: 'Pošalji',
    pushToShopify: 'Pošalji na Shopify',
    complete: 'Završi',
    duplicate: 'Dupliciraj',
    delete: 'Obriši',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Skica narudžbe',
    manualInvoice: 'Ručni račun',
  },
  draftSearch: {
    createdBtw: 'Stvoreno izm.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Kupac',
    status: 'Status',
    type: 'Tip',
    delivery: 'Dostava',
    any: 'Sve',
    draft: 'Skica',
    sent: 'Poslano',
    accepted: 'Prihvaćeno',
    expired: 'Isteklo',
    converted: 'Pretvoreno',
    cancelled: 'Otkazano',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Skica narudžbe',
    manualInvoice: 'Ručni račun',
    delivered: 'Dostavljeno',
    notDelivered: 'Nije dostavljeno',
    pending: 'Na čekanju',
    search: 'Traži',
  },
  draftDownload: {
    title: 'Preuzmi Skica #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Tip',
    any: 'Sve',
    draft: 'Skica',
    sent: 'Poslano',
    accepted: 'Prihvaćeno',
    expired: 'Isteklo',
    converted: 'Pretvoreno',
    cancelled: 'Otkazano',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Skica narudžbe',
    manualInvoice: 'Ručni račun',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instaliraj novi predložak',
    tabStyle: 'Stil',
    tabContent: 'Sadržaj',
    tabTranslations: 'Prijevodi',
    tabSettings: 'Postavke',
    tabCode: 'Kod',
    tabCopilot: 'AI Kopilot',
    logo: 'Logo',
    colorPalette: 'Paleta boja',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/hr.js